import { Navigation } from 'swiper/modules';

const commonCarouselConfig = (id: string) => ({
  navigation: {
    prevEl: `.carousel-prev-${id},.carousel-prev-chevron-${id}`,
    nextEl: `.carousel-next-${id},.carousel-next-chevron-${id}`,
  },
  modules: [Navigation],
  loop: false,
  centerInsufficientSlides: true,
});

export default commonCarouselConfig;
